import React, { useEffect, useState } from "react";
import { MDBTooltip } from "mdb-react-ui-kit";
import { successMsg } from "../SuccessHandler";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import ProfilesCategoriesTable from "../tables/ProfilesCategoriesTable";
import ErrorCodes from "../../constants/ErrorCodes";
import Select from "react-select";
import { useDeleteFunctions } from "../../functions";
import ConfirmDialog from "../utilities/ConfirmDialog";

const AltCategoriesTable = ({
  altCategories,
  setAltCategories,
  data,
  divRef,
  tableRef,
  shouldFocusLast,
  setShouldFocusLast,
  setHasChanges,
  trackCategoryCbx,
  trackList,
  profiles,
  associatedProfiles,
  setAssociatedProfiles,
  viewProfiles,
  setViewProfiles,
  setSessionNoLongerExists,
}) => {
  const [shadedRow, setShadedRow] = useState(null);
  const [editingCategory, setEditingCategory] = useState(null);
  const [editingTrack, setEditingTrack] = useState(null);
  const { deleteTrackAltCategory } = useDeleteFunctions();
  const [selectedRow, setSelectedRow] = useState(0);
  let headers,
    tableContent = [];

  // Highlights the last track inserted in the track table
  useEffect(() => {
    if (shouldFocusLast && tableRef.current) {
      if (tableRef.current) {
        const rows = tableRef.current.getElementsByTagName("tr");
        const secondLastRow = rows[rows.length - 2];
        const lastRow = rows[rows.length - 1];
        secondLastRow.style.backgroundColor = null;
        lastRow.style.backgroundColor = "#ccf5ff";
        lastRow.scrollIntoView();
      }
      const div = divRef.current;
      if (div) {
        div.scrollTop = div.scrollHeight;
      }

      setShouldFocusLast(false);
    }
  }, [shouldFocusLast]);

  // Onchange Alt Categories Table
  const altCategoriesTableChangeHandler = (e) => {
    const x = [...altCategories];
    const name = e.target.name;
    const key = e.target.dataset?.key ?? e.key;
    let value = e.target.value;

    if (name === "IDTrackCategory" || name === "TrackID") {
      value = parseInt(value);
    }

    if (name === "TrackID") {
      const selectedTrack = trackList.find((track) => track.TrackID === value);
      x[key]["ProviderName"] = selectedTrack?.ProviderName || null;
    }

    x[key][name] = value;
    x[key]["Change"] = true;

    setAltCategories(x);
    setHasChanges(true);
  };

  // Profiles OnChange
  const profilesCategoryChangeHandler = (profileID, categoryID) => {
    const x = [...altCategories];

    x.forEach((profile) => {
      if (profile.IDAltTrackCategory === categoryID) {
        if (profile.Profiles.find((pr) => pr.ProfileID === profileID)) {
          profile.Profiles = profile.Profiles.filter(
            (item) => item.ProfileID !== profileID
          );
        } else {
          profile.Profiles = [...profile.Profiles, { ProfileID: profileID }];
        }
      }
    });

    x.forEach((item) => {
      if (item.IDAltTrackCategory === categoryID) {
        item.Change = true;
      }
    });

    setAltCategories(x);
    setHasChanges(true);
  };

  // Delete Alt Categories Function
  const handleDeleteAltCategory = (event, info, i) => {
    ConfirmDialog(`Do you want to delete Alternate Category?`).then(
      async (result) => {
        if (result.isConfirmed) {
          const res = await deleteTrackAltCategory(
            {
              DeleteID: info.IDAltTrackCategory,
            },
            data
          );

          if (res?.error) {
            if (
              res.Result === ErrorCodes.InvalidSession ||
              res.Result === ErrorCodes.SessionNoLongerExists
            ) {
              setSessionNoLongerExists(true);
            }

            return;
          } else {
            // This code removes the row shadow only if the row to be removed is the selected row and clears the associated profiles
            const row = event.target.closest("tr");
            if (row) {
              if (shadedRow === row) {
                shadedRow.classList.remove("shadedRow");
                setShadedRow(null);
                setAssociatedProfiles([]);
              }
            }
            setViewProfiles(false);
            successMsg("Delete Alt Category successfully");
            const updatedItems = [...altCategories];
            updatedItems.splice(i, 1);
            setAltCategories(updatedItems);
          }
        }
      }
    );
  };

  // Onchange for the Date Picker
  const dateChange = (dateC, id) => {
    if (dateC === null) {
      setAltCategories({
        ...altCategories,
        DateFrom: null,
      });
    } else {
      const originalDate = new Date(dateC);
      originalDate.setHours(originalDate.getUTCHours());
      const pacificDate = originalDate.toISOString();
      const dateFrom = new Date(pacificDate);

      // Obtener fecha y hora en formato UTC
      const year = dateFrom.getFullYear();
      const month = ("0" + (dateFrom.getUTCMonth() + 1)).slice(-2);
      const day = ("0" + dateFrom.getUTCDate()).slice(-2);
      const hours = ("0" + dateFrom.getUTCHours()).slice(-2);
      const minutes = ("0" + dateFrom.getMinutes()).slice(-2);
      const seconds = ("0" + dateFrom.getSeconds()).slice(-2);

      // Crear cadena en formato ISO 8601
      const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;

      setAltCategories((prevState) => {
        const newData = prevState.map((item) => {
          if (item.IDAltTrackCategory === id) {
            return {
              ...item,
              DateFrom: isoString,
              Change: true,
            };
          }
          return item;
        });
        return newData;
      });
      setHasChanges(true);
    }
  };

  // This function is called when the user clicks on the button View Associated Profiles
  const viewProfilesCategories = (row, category) => {
    setAssociatedProfiles(category, { Profiles: category.Profiles });
    setViewProfiles(true);
    setSelectedRow(row.IDAltTrackCategory);
  };

  // The main Alternate Category table is populated
  if (altCategories) {
    tableContent = altCategories.map((item, i) => {
      return (
        <React.Fragment key={i}>
          <tr
            key={item.IDAltTrackCategory}
            onClick={(e) =>
              viewProfilesCategories(
                item,
                altCategories.filter(
                  (profiles) =>
                    profiles.IDAltTrackCategory === item.IDAltTrackCategory
                )[0]
              )
            }
            className={
              selectedRow === item.IDAltTrackCategory ? "shadedRow" : ""
            }
          >
            <td key={"IdTrackCategory" + i} className="d-none">
              {item.IDAltTrackCategory}
            </td>
            {/* Date */}
            <td
              key={"Date" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
                width: "200px",
              }}
            >
              <DatePicker
                selected={Date.parse(item.DateFrom)}
                dateFormat="MM/dd/yyyy"
                className="form-control"
                wrapperClassName="datePicker"
                id="DateFrom"
                name="DateFrom"
                autoComplete="off"
                placeholderText="Date"
                onChange={(e) => dateChange(e, item.IDAltTrackCategory)}
              />
            </td>
            {/* Provider */}
            <td
              style={{
                whiteSpace: "normal",
                width: "160px",
                textAlign: "center",
                verticalAlign: "middle",
                fontSize: "14px",
                color: "#495057",
              }}
            >
              {item.ProviderName}
            </td>
            {/* Track */}
            <td
              key={"Track" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
                width: "450px",
              }}
              onClick={() => {
                setEditingTrack(item.IDAltTrackCategory);
              }}
              onFocus={() => {
                setEditingTrack(item.IDAltTrackCategory);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setEditingTrack(item.IDAltTrackCategory);
                }
              }}
            >
              {editingTrack === item.IDAltTrackCategory ? (
                <Select
                  autoFocus
                  onFocus={() =>
                    viewProfilesCategories(
                      item,
                      altCategories.find(
                        (profiles) =>
                          profiles.IDAltTrackCategory ===
                          item.IDAltTrackCategory
                      )
                    )
                  }
                  value={trackList
                    .map((tz) => ({
                      value: tz.TrackID,
                      label: `${tz.TrackCode} - ${tz.TrackName}`,
                    }))
                    .find((opt) => opt.value === item.TrackID)}
                  options={trackList
                    .filter(
                      (tz) =>
                        !altCategories.some(
                          (cat, index) =>
                            index !== i && cat.TrackID === tz.TrackID
                        )
                    )
                    .map((tz) => ({
                      value: tz.TrackID,
                      label: `${tz.TrackCode} - ${tz.TrackName}`,
                    }))}
                  onChange={(selectedOption) => {
                    altCategoriesTableChangeHandler({
                      target: {
                        name: "TrackID",
                        value: selectedOption?.value,
                      },
                      key: i,
                    });
                    setEditingTrack(null);
                  }}
                  onBlur={() => setEditingTrack(null)}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      minWidth: 167,
                      fontSize: 12,
                    }),
                    control: (provided) => ({ ...provided, fontSize: 12 }),
                  }}
                />
              ) : (
                <label
                  tabIndex={0}
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditingTrack(item.IDAltTrackCategory);
                    const tr = e.currentTarget.closest("tr");
                    if (tr) {
                      tr.dispatchEvent(
                        new MouseEvent("click", { bubbles: true })
                      );
                    }
                  }}
                  style={{
                    fontSize: "12px",
                    width: "210px",
                    cursor: "pointer",
                    color: "#495057",
                  }}
                >
                  {(
                    trackList.find((tz) => tz.TrackID === item.TrackID) || {
                      TrackCode: "-",
                      TrackName: "",
                    }
                  ).TrackCode +
                    " - " +
                    (
                      trackList.find((tz) => tz.TrackID === item.TrackID) || {
                        TrackName: "",
                      }
                    ).TrackName}
                </label>
              )}
            </td>
            {/* Category */}
            <td
              style={{ verticalAlign: "middle", textAlign: "center" }}
              onClick={() => {
                setEditingCategory(item.IDAltTrackCategory);
              }}
              onFocus={() => {
                setEditingCategory(item.IDAltTrackCategory);
              }}
            >
              {editingCategory === item.IDAltTrackCategory ? (
                <Select
                  autoFocus
                  onFocus={() =>
                    viewProfilesCategories(
                      item,
                      altCategories.find(
                        (profiles) =>
                          profiles.IDAltTrackCategory ===
                          item.IDAltTrackCategory
                      )
                    )
                  }
                  value={trackCategoryCbx
                    .map((cat) => ({
                      value: cat.IDTrackCategory,
                      label: cat.Description,
                    }))
                    .find((opt) => opt.value === item.IDTrackCategory)}
                  options={trackCategoryCbx.map((cat) => ({
                    value: cat.IDTrackCategory,
                    label: cat.Description,
                  }))}
                  onChange={(selectedOption) => {
                    altCategoriesTableChangeHandler({
                      target: {
                        name: "IDTrackCategory",
                        value: selectedOption?.value,
                      },
                      key: i,
                    });
                    setEditingCategory(null);
                  }}
                  onBlur={() => setEditingCategory(null)}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      minWidth: 130,
                      fontSize: 12,
                    }),
                    control: (provided) => ({ ...provided, fontSize: 12 }),
                  }}
                />
              ) : (
                <label
                  tabIndex={0}
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditingCategory(item.IDAltTrackCategory);
                    const tr = e.currentTarget.closest("tr");
                    if (tr) {
                      tr.dispatchEvent(
                        new MouseEvent("click", { bubbles: true })
                      );
                    }
                  }}
                  onFocus={() => {
                    setEditingCategory(item.IDAltTrackCategory);
                  }}
                  style={{
                    fontSize: "12px",
                    width: "120px",
                    cursor: "pointer",
                    color: "#495057",
                  }}
                >
                  {trackCategoryCbx.find(
                    (cat) =>
                      Number(cat.IDTrackCategory) ===
                      Number(item.IDTrackCategory)
                  )?.Description || "-"}
                </label>
              )}
            </td>
            {/* Delete */}
            <td
              style={{
                textAlign: "center",
                verticalAlign: "middle",
              }}
              key={"del" + i}
            >
              <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="Delete">
                <i
                  className="fas fa-trash-alt"
                  style={{
                    color: "#ff0000",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                  onClick={(e) => handleDeleteAltCategory(e, item, i)}
                ></i>
              </MDBTooltip>
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  // Alt categories table headers
  headers = (
    <tr className="text-center">
      <th hidden>AltCategoryID</th>
      <th>Date</th>
      <th>Provider</th>
      <th>Track</th>
      <th>Category</th>
      <th></th>
      <th></th>
    </tr>
  );

  return (
    <>
      <div className="row">
        <div
          className="divTables col-md-12 col-xl-8"
          style={{ overflow: "auto", marginTop: "10px" }}
          ref={divRef}
        >
          <table className="table table-sm" ref={tableRef}>
            <thead
              style={{ position: "sticky", top: "0", background: "white" }}
            >
              {headers}
            </thead>
            <tbody className="table-lg">{tableContent}</tbody>
          </table>
        </div>
        <div className="col-md-12 col-xl-4">
          <div style={{ textAlign: "center" }}>
            <h4 className="lead mt-2" style={{ color: "#138496" }}>
              Associated Profiles
            </h4>
          </div>
          <div>
            {viewProfiles && (
              <ProfilesCategoriesTable
                profiles={profiles}
                associatedProfiles={associatedProfiles}
                profilesCategoryChangeHandler={profilesCategoryChangeHandler}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AltCategoriesTable;
